import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import { useFlowDetails } from '../api';
import FlowForm from './FlowForm';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';
import { cabinetDatadogSources } from 'lib/datadog';

const EditFlowComponent: FC = () => {
  const { flowId } = useParams();
  const { data } = useFlowDetails({ params: { id: flowId } });

  if (!flowId) return <Navigate to={'/'} />;
  return <FlowForm data={data} />;
};

const EditFlow: FC = () => {
  return (
    <SuspenseBoundary
      fallback={<FormSkeleton />}
      datadogSource={cabinetDatadogSources.detailsQuery('tiktok', 'flow')}
    >
      <EditFlowComponent />
    </SuspenseBoundary>
  );
};

export default EditFlow;
